/* eslint-disable consistent-return */
import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_PROJECT_VARIABLES_SUCCESS = 'GET_PROJECT_VARIABLES_SUCCESS'
export const GET_PROJECT_VARIABLES_FAILURE = 'GET_PROJECT_VARIABLES_FAILURE'

// -- CREATE
export const CREATE_PROJECT_VARIABLE_SUCCESS = 'CREATE_PROJECT_VARIABLE_SUCCESS'
export const CREATE_PROJECT_VARIABLE_FAILURE = 'CREATE_PROJECT_VARIABLE_FAILURE'

// -- UPDATE
export const UPDATE_PROJECT_VARIABLE_SUCCESS = 'UPDATE_PROJECT_VARIABLE_SUCCESS'
export const UPDATE_PROJECT_VARIABLE_FAILURE = 'UPDATE_PROJECT_VARIABLE_FAILURE'

// -- DELETE
export const DELETE_PROJECT_VARIABLE_SUCCESS = 'DELETE_PROJECT_VARIABLE_SUCCESS'
export const DELETE_PROJECT_VARIABLE_FAILURE = 'DELETE_PROJECT_VARIABLE_FAILURE'

// -- SEARCH
export const SEARCH_PROJECT_VARIABLES = 'SEARCH_PROJECT_VARIABLES'

// ____________________________________________________________

/**
 * SEARCH for a project variable attribute based on its name.
 *
 * @param {string} terms Text to be searched within the project's parameter.
 * @returns {Promise<array<object>>}
 */
export const searchProjectVariables = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_PROJECT_VARIABLES,
    data: terms
  })
}

/**
 * GET the list of variables attributes that belong to this project.
 *
 * @param {uuid} pid Project ID
 * @returns {Array<object>}
 */
export const getProjectVariables = (pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_VARIABLE_LIST, { pid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] variablesActions.getProjectVariables()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_PROJECT_VARIABLES_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_PROJECT_VARIABLES_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific variable attribute that belong to a project.
 *
 * @param {object} newVariable New variable to create.
 * @param {uuid} pid Project ID.
 * @returns {Array<object>}
 */
export const createProjectVariable = (newVariable, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_VARIABLE_CREATE, { pid })
  const api = new Api(path)
  const result = await api.create(newVariable)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] variablesActions.createProjectVariable()', { pid, path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_PROJECT_VARIABLE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_PROJECT_VARIABLE_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific project variable attribute.
 *
 * @param {object} newVariable Variable object to update.
 * @param {uuid} vid Project Variable ID.
 * @param {uuid} pid Project ID.
 * @returns {Array<object>}
 */
export const updateProjectVariable = (newVariable, vid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_VARIABLE_UPDATE, { pid, vid })
  const api = new Api(path)
  const result = await api.update(newVariable)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] variablesActions.editVariable()', { path, newVariable, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_PROJECT_VARIABLE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_PROJECT_VARIABLE_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific project variable attribute.
 *
 * @param {uuid} vid Project Variable ID.
 * @param {uuid} pid Project ID.
 * @returns {Array<object>}
 */
export const deleteProjectVariable = (vid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_VARIABLE_DELETE, { pid, vid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] variablesActions.deleteProjectVariable()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_PROJECT_VARIABLE_SUCCESS,
      data: vid
    })
  }
  return dispatch({
    type: DELETE_PROJECT_VARIABLE_FAILURE,
    data: result.data
  })
}
